export function formatAcceptLanguage(acceptLanguage: string) {
  return Array.from(
    // Convert Set to Array to be able to use find
    // Use a Set to remove duplicates
    new Set(
      acceptLanguage.split(',').map((lang) => {
        const noPrio = lang.split(';')[0]
        const noRegion = noPrio?.split('-')[0]

        // Convert Norwegian and Nynorsk to Norwegian Bokmål
        if (noRegion === 'no' || noRegion === 'nn') {
          return 'nb'
        }

        return noRegion || ''
      }),
    ),
  )
}
